import Icon from 'vue-awesome/components/Icon'

Icon.register({
  signal_wifi_off_two_tone: {
    paths: [
      {
        d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM3.41 1.31L2 2.72l2.05 2.05C1.91 5.76.59 6.82.36 7L12 21.5l3.91-4.87 3.32 3.32 1.41-1.41L3.41 1.31z'
      }
    ],
    width: '24',
    height: '24'
  }
})
